<template>
  <div class="smsc-container">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="filters-container flex flex-wrap items-center justify-start pb-3">
          <div class="mt-3 mr-3" style="min-width: 300px">
            <label class="vs-input--label">STARTING DATE</label>
            <div>
              <flat-pickr
                :config="{
                      ...configdateTimePicker,
                      defaultDate: new Date().setHours(0, 0, 0),
                      onReady: SetDatetimeForStart,
                      onChange: SetDatetimeForStart,
                    }"
                class="w-100"
                v-model="start_date"
              />
            </div>
          </div>
          <div class="form-group has-search ml-3 position-relative t-2"style="top: 15px!important;">
            <span class="fa fa-search form-control-company-feedback"></span>
            <input
              @input="SearchUser()"
              id="quickFilter"
              v-model="search_balance"
              class="filter_input_company form-control-company "

            >
          </div>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
        </div>
      </div>
    </vx-card>
    <vx-card>
      <!-- Per Page -->
      <div class="mb-4 md:mb-0">
        <per-page
          :currentPerPage="per_page"
          :pageStart="pageStart"
          :pageEnd="pageEnd"
          :total="total"
          @change-per-page="ChangePerPage($event)"
        />
      </div>

      <!-- Table -->
      <ag-grid-vue
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="list"
        @gridReady="GridReady"
        @filterChanged="Filtering"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="isFloatingFilter"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
  // Mixins
  import TableMixin from "@/mixins/table.js"
  import DateTimeMixin from '@/mixins/datetime.js'
    import {AgGridVue} from "ag-grid-vue";
    import flatPickr from 'vue-flatpickr-component'
    import 'flatpickr/dist/flatpickr.css'
    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import CellRendererActions from "../bulk-report/cell-renderer/CellRendererActions";

    export default {
      mixins: [TableMixin, DateTimeMixin],
        name: "List",
      components: {
        AgGridVue,
        flatPickr,
        CellRendererActions

        //Cell Renderer components
      },
      data:() =>({
        search_balance:'',
        totalPages:'',
        start_date: null,
        // start_time: parseInt(this.$route.query.start_time ) || 0,
        list:[],
        gridOptions: {},
        columnDefs: [
          {
            headerName: 'User Name',
            field: 'did',
            minWidth: 220,
            checkboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            headerCheckboxSelection: true
          },
          {
            headerName: 'Balance',
            field: 'created_on',
            minWidth: 220
          },

          {
            headerName: 'State',
            field: 'state',
            minWidth: 220
          },
          {
            headerName: 'Lata',
            field: 'lata',
            minWidth: 220
          },

          {
            headerName: 'Action',
            flex: 0,
            cellRendererFramework: 'CellRendererActions',
            minWidth: 100,
          },

        ],

        components:{CellRendererActions},
      }),


      computed: {
      /*  paginationPageSize () {
          if (this.gridApi) return this.gridApi.paginationGetPageSize()
          else return 50
        },
        totalPages () {
          if (this.gridApi) return this.gridApi.paginationGetTotalPages()
          else return 0
        },
        currentPage: {
          get () {
            if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
            else return 1
          },
          set (val) {
            this.gridApi.paginationGoToPage(val - 1)
          }
        }*/
      },
      mounted() {
        this.gridApi = this.gridOptions.api;
        this.gridApi.sizeColumnsToFit()

      },
      created() {

          this.GetList()
      },

      methods:{
        GetList () {
          // this.$vs.loading()
          this.$store.dispatch('bulk/GetList', {
            ...this.filters,
            page: this.page || 0,
            per_page: this.per_page || 20,
            order_by: this.order_by || 'started_at',
            order_dir: this.order_dir || 'desc',
            bulk_uuid: this.searchProduct + "*"
          })
            .then(res => {
              this.list = res.items.map(this.TransformList)
              this.total = res.total
            })
            .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
            .finally(() => this.$vs.loading.close())
        },
        SearchUser(){
          this.GetList()
        },
        SetDatetimeForStart(e) {
          this.filters.start_time = e[0].getTime() / 1000
        },
      }
    }
</script>

<style scoped>
  .filter_input_company{
    padding: 17px;
    padding-left: 55px;
    width: 220px;
    height: 41px;
    border: 1px solid #f5f5f5;
    font-size: 13px;
    color: gray;
    background-repeat: no-repeat;
    background-position: left center;
    outline: 0;
  }
  .has-search .form-control-company-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 15px;
    height: 15px;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: gray;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
  }
</style>
